/**
 * Escape user-controlled strings for safe interpolation into HTML/innerHTML.
 * Use everywhere we build markup strings that include backend data.
 */
export function esc(value) {
  if (value == null) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
